import {
  BLOCKER_ID,
  POPUP_SHARE_ID,
  showSiteBlocker,
  hideSiteBlocker,
  getTransitionTime,
  showElementTransition,
  hideElementTransition,
} from '../components/popup';

document.addEventListener('DOMContentLoaded', function() {
  const TRANSITION_SPEED = 'fast';
  const SITE_BLOCKER = $(BLOCKER_ID);

  const POPUP_SHARE_BUTTON = $('.site-popup__share-button');
  const POPUP_SHARE_CLOSE = $('#site-popup__share .site-popup__share-content .btn.btn--close');
  let POPUP_SHARE;

  async function loadSharingDialogAction(e) {
    let formData = new FormData();

    formData.append('platforms', e.target.dataset.platforms);
    formData.append('contentUid', e.target.dataset.uid);
    formData.append('uri', e.target.dataset.uri);

    let url = '?type=1718312471';

    await $.ajax({
      async: 'true',
      type: 'POST',
      data: formData,
      cache: false,
      processData: false,
      contentType: false,
      url: url,
      crossDomain: true,
      dataType: 'html',
    })
      .done(function(response) {
        POPUP_SHARE = $(response);
        $('body').append(POPUP_SHARE);

        // Click on close x
        POPUP_SHARE.on('click', '.btn.btn--close', function(element) {
          element.preventDefault();
          closePopupShare();
        });
        POPUP_SHARE_BUTTON.removeAttr('disabled').removeClass('disabled');
        SITE_BLOCKER.removeClass('click-blocked');

        showElementTransition(POPUP_SHARE, TRANSITION_SPEED);
        return true;

        /* let directoriesResults = document.getElementsByClassName('directories-results')[0];
          if (directoriesResults) {
            directoriesResults.outerHTML = response;
          } */
      })
      .fail(function(jqXHR, textStatus, error) {
        console.warn('Failure in refreshResultsAction');
        console.log(jqXHR.responseText);
        //console.log(textStatus);
        console.log(error);
        return false;
      });
  }

  // Toggle click on fixed contact button
  POPUP_SHARE_BUTTON.click(function(e) {
    if (POPUP_SHARE_BUTTON.is('disabled')) {
      return;
    }

    //e.preventDefault();

    if (typeof POPUP_SHARE === 'undefined') {
      POPUP_SHARE_BUTTON.attr('disabled', 'disabled').addClass('disabled');
      SITE_BLOCKER.addClass('click-blocked');
      showSiteBlocker(SITE_BLOCKER, TRANSITION_SPEED, POPUP_SHARE_ID);
      loadSharingDialogAction(e);
    } else {
      if (!POPUP_SHARE.hasClass('active')) {
        showSiteBlocker(SITE_BLOCKER, TRANSITION_SPEED, POPUP_SHARE_ID);
        showElementTransition(POPUP_SHARE, TRANSITION_SPEED);
      } else {
        closePopupShare();
      }
    }

    $(e.target).removeAttr('disabled');
  });

  // Close popup function
  function closePopupShare() {
    POPUP_SHARE_BUTTON.removeAttr('disabled');
    hideSiteBlocker(SITE_BLOCKER, TRANSITION_SPEED);
    hideElementTransition(POPUP_SHARE, TRANSITION_SPEED);
  }

  // Expose closePopup to be callable programmatically
  window.closePopupShare = closePopupShare;
});
